<template>
  <v-card>
    <v-dialog v-model="signSendDialog" max-width="500">
      <v-card>
        <v-card-title class="primary py-3 pr-5 fixedTop white--text title">
          Sign and Send
        </v-card-title>
        <v-card-text>
          <v-flex v-if="sending" class="text-xs-center">
            Generating a new order and sending to
            <strong>{{ currentServiceItem ? currentServiceItem.email : customer.email }}</strong>
          </v-flex>
          <v-flex v-else class="text-xs-center">
            You are about to create and send an order directly to
            <strong>{{ currentServiceItem ? currentServiceItem.email : customer.email }}</strong>
            for signing
          </v-flex>

          <v-progress-linear
            v-if="sending"
            indeterminate
            color="primary"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="sending" class="primary" @click="send">Send</v-btn>
          <v-btn
            :disabled="sending"
            class="light-grey"
            @click="signSendDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showInfoDetailsDialog" persistent width="500">
      <v-card>
        <v-card-title class="primary py-3 pr-5 white--text title">Softphone Info Details</v-card-title>
        <v-card-text>
          <v-flex class="mb-4">
            <vonex-text
              v-model="softPhoneDetails.firstName"
              label="First Name"
              :name="`firstName`"
              data-vv-as="First Name"
              :options="fieldConditions"
              :rule="`required`"
              hide-details
              class="custom-td"
            ></vonex-text>
          </v-flex>
          <v-flex class="mb-4">
            <vonex-text
              v-model="softPhoneDetails.lastName"
              label="Last Name"
              :name="`lastName`"
              data-vv-as="Last Name"
              :rule="`required`"
              :options="fieldConditions"
              hide-details
              class="custom-td"
          ></vonex-text>
          </v-flex>
          <v-flex class="mb-4">
            <vonex-text
              v-model="softPhoneDetails.email"
              label="Email"
              data-vv-as="Email"
              :name="`email`"
              :rule="`required|email`"
              :options="fieldConditions"
              hide-details
              class="custom-td"
            >
          </vonex-text>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="primary" @click="saveInfoDetails">Save</v-btn>
            <v-btn class="light-grey" @click="closeInfoDetails">Cancel</v-btn>
          </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card-title class="primary py-3 pr-5 white--text title">
      Add Softphone to Existing Services - Customer #{{ customer.ubAccountNo }}
    </v-card-title>

    <v-card-text>
      <v-flex offset-xs8>
        <v-spacer></v-spacer>
        <vonex-text
          v-model="search"
          solo
          prepend-inner-icon="search"
          clearable
          label="Search"
          hide-details
          :options="fieldConditions"
        ></vonex-text>
        <!-- <v-text-field
          solo
          prepend-inner-icon="search"
          clearable
          v-model="search"
          label="Search"
          hide-details
        ></v-text-field> -->
      </v-flex>
      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="services.filter((x) => x.type === 'VoIP' && x.contractLengthMonths == 12)"
          :search="search"
          class="elevation-1 mt-3"
          :pagination.sync="pagination"
          :rows-per-page-items="rowsPerPageItems"
        >
          <template v-slot:items="props">
            <td>{{ props.item.type }}</td>
            <td>{{ props.item.service }}</td>
            <td>{{ props.item.extension }}</td>
            <td>{{ props.item.plan }}</td>
            <td>
              <v-chip v-if="props.item.addSoftphone" class="primary" dark>
                Vonex Softphone $3
              </v-chip>
            </td>
            <td>{{ props.item.name }}</td>
            <td>
              <!-- disable button if props.item.addSoftphone is false -->
              <v-btn color="secondary" class="square-btn" :disabled="!props.item.addSoftphone" @click="showInfoDetails(props.item)">See info details
              </v-btn>
            </td>
            <!-- <td>
              <vonex-text
                v-model="props.item.firstName"
                label="First Name"
                :name="`firstName` + props.index"
                data-vv-as="First Name"
                :disabled="!props.item.addSoftphone"
                :options="fieldConditions"
                :rule="props.item.addSoftphone ? 'required' : ''"
                hide-details
                class="custom-td"
              ></vonex-text>
            </td>
            <td>
              <vonex-text
                v-model="props.item.lastName"
                label="Last Name"
                :name="`lastName` + props.index"
                data-vv-as="Last Name"
                :disabled="!props.item.addSoftphone"
                :rule="props.item.addSoftphone ? 'required' : ''"
                :options="fieldConditions"
                hide-details
                class="custom-td"
              ></vonex-text>
            </td>
            <td>
              <vonex-text
                v-model="props.item.email"
                label="Email"
                data-vv-as="Email"
                :name="`email` + props.index"
                :disabled="!props.item.addSoftphone"
                :rule="props.item.addSoftphone ? 'required|email' : ''"
                :options="fieldConditions"
                hide-details
                class="custom-td"
              ></vonex-text>
            </td> -->
            <td>
              <vonex-checkbox
                v-if="isAllowed(props.item)"
                v-model="props.item.addSoftphone"
                :input-value="props.item.addSoftphone"
                hide-details
                color="primary"
                :options="fieldConditions"
                class="custom-td"
                @change="addSelectedSoftphone(props.item)"
              ></vonex-checkbox>
              <!-- <v-checkbox
              v-model="props.item.addSoftphone"
              v-if="isAllowed(props.item)"
              hide-details
              color="primary"
              @change="addSelectedSoftphone(props.item)"
            ></v-checkbox> -->
            </td>
          </template>

          <template v-slot:no-data>
            <v-alert v-if="!loading" :value="true" color="error" icon="warning">
              No eligible existing services
            </v-alert>
          </template>
        </v-data-table>
      </ValidationObserver>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn
        class="primary"
        :disabled="selected.length === 0"
        @click="openSignAndSend"
      >
        Sign and Send
      </v-btn>
      <v-btn
        :disabled="services.filter((x) => x.type === 'VoIP').length === 0"
        class="primary"
        @click="selectAllItems()"
      >
        Select all items (SoftPhone)
      </v-btn>
      <v-btn class="light-grey" @click="close">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, createNamespacedHelpers } from 'vuex';
import { IPVoiceService } from '../models/IPVoiceService';
import {
  mapIPVoiceFields,
  mapIPVoiceMultiRowFields,
} from '../store/modules/orders';

const { mapActions: mapIPVoiceActions } =
  createNamespacedHelpers(`orders/ipVoice`);
const {
  mapGetters: mapCustomerGetters,
  mapMutations: mapCustomerMutations,
  mapActions: mapCustomerActions,
} = createNamespacedHelpers(`orders/customer`);
import { httpError } from '../models/httpError';

const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

export default {
  name: 'ExistingServices',
  props: {
    account: Number,
    services: Array,
    customer: Object,
    listCustomerOpen: Boolean,
  },
  data() {
    return {
      rowsPerPageItems: [
        { text: '15', value: 15 },
        { text: '30', value: 30 },
        { text: '45', value: 45 },
        { text: 'All', value: -1 },
      ],
      headers: [
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Service', value: 'service', sortable: false },
        { text: 'Extension', value: 'extension', sortable: false },
        { text: 'Plan', value: 'plan', sortable: false },
        { text: 'Note', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Details', value: 'details', sortable: false },
        // {
        //   text: 'First Name',
        //   value: 'softphoneDetails.firstName',
        //   sortable: false,
        // },
        // {
        //   text: 'Last Name',
        //   value: 'softphoneDetails.lastName',
        //   sortable: false,
        // },
        // { text: 'Email', value: 'softphoneDetails.email', sortable: false },
        { text: 'Add', value: 'addSoftPhone', sortable: false },
      ],
      pagination: {
        rowsPerPage: 15,
      },
      loading: true,
      voip: [],
      totalItems: 0,
      search: '',
      disable: true,
      selected: [],
      showAll: false,
      NumberOfIPVoices: 0,
      selectAllDisable: false,
      signSendDialog: false,
      sending: false,
      showInfoDetailsDialog: false,
      currentServiceItem: null,
      softPhoneDetails: {
        lastName: '',
        firstName: '',
        email: '',
      },
    };
  },
  computed: {
    ...mapCustomerGetters(['getCurrentCustomer']),
    ...mapIPVoiceMultiRowFields(['rows', 'ratePlans']),
  },
  methods: {
    ...mapIPVoiceActions(['setMessage', 'getServices']),
    ...mapOrderActions(['addSoftPhoneOrder', 'setMessage']),
    ...mapCustomerActions(['getDealerCustomer', 'getCustomer']),

    isAllowed(item) {
      if (
        !item.plan.toLowerCase().includes('softphone') &&
        !item.plan.toLowerCase().includes('hunt') &&
        !item.released
      )
        return true;
      else return false;
    },
    addSelectedSoftphone() {
      this.selected = this.services.filter((x) => x.addSoftphone);
    },
    openSignAndSend() {
      let vm = this;
      vm.$refs.observer
        .validate()
        .then((result) => {
          if (result) this.signSendDialog = true;
          else
            vm.setMessage({
              message: 'Check missing fields above',
              httpStatus: 500,
            });
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    selectAllItems() {
      let vm = this;
      vm.selected = [];
      vm.services.forEach((x) => {
        if (
          x.type === 'VoIP' &&
          !x.plan.toLowerCase().includes('softphone') &&
          !x.plan.toLowerCase().includes('hunt') &&
          !x.released
        ) {
          x.addSoftphone = 1;
          vm.selected.push(x);
        }
      });

      this.selectAllDisable = true;
    },
    showInfoDetails(item) {
      this.currentServiceItem = item;
      this.showInfoDetailsDialog = true;
      const email = item.email || '';

      if (email.includes(';')) {
        this.softPhoneDetails.email = email.split(';')[0];
      } else {
        this.softPhoneDetails.email = email;
      }
      this.softPhoneDetails.firstName = item.firstName || '';
      this.softPhoneDetails.lastName = item.lastName || '';
    },
    saveInfoDetails() {
      if (!this.currentServiceItem) {
        return;
      }
      this.currentServiceItem.firstName = this.softPhoneDetails.firstName;
      this.currentServiceItem.lastName = this.softPhoneDetails.lastName;
      this.currentServiceItem.email = this.softPhoneDetails.email;
      this.showInfoDetailsDialog = false;
    },
    closeInfoDetails() {
      this.showInfoDetailsDialog = false;
      this.currentServiceItem = null;
    },
    close() {
      this.$emit('close', []);
    },
    send() {
      let vm = this;
      vm.sending = true;

      //Transform the requisite services into new rows.
      let newRows = [];
      if (vm.rows.length > 0 && vm.rows[0].ipExtensionID == 0) {
        vm.rows.splice(0, 1);
      }

      let nextExt = vm.rows.length;
      nextExt = 500 + nextExt;
      if (this.selected.length > 0) {
        let index = 0;
        this.selected.forEach((sv) => {
          const extensionDigits = sv.extension?.replace(/\D/g, '');

          sv.extensionNo = extensionDigits ? parseInt(extensionDigits, 10) : sv.service;
          sv.extensionName = sv.name;
          // sv.upgrade = true;
          sv.contractLengthMonths = 12;
          sv.ratePlanID = process.env.SOFTPHONE;
          sv.softPhone = true;
          sv.handsetID = 10016;

          let newService = new IPVoiceService(sv);
          newService.softPhoneDetails.userName = '';
          newService.softPhoneDetails.firstName = sv.firstName;

          newService.softPhoneDetails.lastName = sv.lastName;

          newService.softPhoneDetails.email = sv.email;

          newRows.push(newService);
          nextExt++;
          index++;
        });
      }

      if (this.selected.length > 0) {
        let vm = this;
        let items = { customer: this.account, extensions: newRows };

        vm.addSoftPhoneOrder(items)
          .then((response) => {
            this.setMessage({
              message: `Order #${response} created and has been sent to customer`,
              httpStatus: 200,
            });
            vm.$emit('close', []);
            vm.sending = false;
          })
          .catch((err) => {
            vm.isLoading = false;
            new httpError({
              message: 'Unable to send message: ' + err.message,
              httpStatus: 500,
            });

            vm.$emit('close', []);
            vm.sending = false;
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/custom-styles.scss';
.fixedTop {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 999;
}
.invalid {
  background-color: coral;
}
</style>
